import React from 'react';
import Welcome from './Welcome';
import { useNavigationContext } from '../../../contexts/NavigationContext';
import Navbar from '../common/navbar/Navbar';
import PropertyPage from './properties/PropertyPage';

import NewsPage from '../news/NewsPage';
import { CONSTANT } from '../../../utils/constants';

import './DiardExpertise.scss';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (
    <div className="flex flex-row h-screen w-screen">
      <div className="min-w-64 w-64">
        <Navbar />
      </div>
      <div className="w-full h-auto overflow-scroll">
        <NewsPage
          isActive={navigationContext.acitveAppKey === 'news'}
          scope={'diardexpertise'}
          tagsType={'def_keywords'}
          typeList={CONSTANT.diardexpertise.availableNewsTypes}
        />
        <PropertyPage isActive={navigationContext.acitveAppKey === 'defproperty'} />

        <Welcome isActive={!navigationContext.acitveAppKey} />
      </div>
    </div>
  );
}

export default Home;
